<template>
  <div
    class="relative py-1"
    :class="{ 'opacity-50': readonly, 'pb-15px': errorOn }"
    style="transition: padding 0.2s ease"
  >
    <div v-click-outside="toggleOutside" class="relative">
      <label
        ref="label"
        :for="name"
        :class="`z-10 bg-${bg || 'white'} ${
          underlined ? '-ml-2' : ''
        } text-gray-600 absolute leading-none pointer-events-none text-base`"
        >{{ name }}</label
      >
      <div
        :class="`border-${borderColor}-400 flex items-center py-2 px-3 ${
          underlined ? `py-2 border-b${errorOn ? '-2' : ''} border-gray-500` : 'border-2 rounded'
        }`"
        style="transition: border 0.2s ease"
      >
        <div
          v-if="prefix"
          :class="`${sharedInputStyling} text-green-500 text-sm font-bold mr-3`"
          @click="$refs.input.focus()"
        >
          {{ prefix }}
        </div>

        <input
          ref="input"
          v-model="dropdownValue"
          readonly="false"
          type="text"
          :maxlength="524288"
          underlined="true"
          :id="id"
          :class="`${sharedInputStyling} ${
            inputClass ? inputClass : ''
          } flex-1 appearance-none outline-none -ml-2 truncate min-w-120px`"
          @focus="handleFocus()"
          @blur="handleBlur()"
        />

        <transition name="in--down">
          <div
            v-if="toggled"
            class="mt-5 z-40 absolute flex flex-col overflow-y-scroll bg-white shadow border rounded-b inset-x-0 top-0 absolute text-left focus:outline-none"
            style="margin-top: 39px; max-height: 225px"
          >
            <button
              ref="dd"
              v-for="d in dropdownOptions"
              v-bind:key="getKeyForOption(d)"
              @click="handleSelect(d)"
              class="hover:bg-gray-200 px-3 py-2 block w-full text-left focus:outline-none"
            >
              {{ d }}
            </button>
          </div>
        </transition>
      </div>
    </div>
    <b v-if="b" class="text-black-500 mt-4">{{ b }}</b>
    <p v-if="p" class="text-sm text-gray-500 pl-1 mt-2">{{ p }}</p>
    <transition name="in--down">
      <div
        v-if="errorOn"
        :class="`absolute pin-r -translate-y-50 bg-${
          bg || 'white'
        } text-red-400 text-xs rounded font-semibold z-50`"
      >
        {{ error }}
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'Dropdown',
  props: [
    'dropdownOptions',
    'value',
    'bg',
    'name',
    'inputClass',
    'b',
    'p',
    'placeholder',
    'error',
    'suffix',
    'suffixIcon',
    'prefix',
    'getter',
    'setter',
    'maxlength',
    'underlined',
    'readonly',
    'type',
    'nextClicked',
    'id'
  ],
  data: function () {
    return {
      toggled: false,
      showError: true,
      placeSwitch: '',
      chosenValue: false,
      sharedInputStyling:
        'text-base leading-none bg-transparent tracking-tight inline-flex items-center'
    }
  },
  computed: {
    errorOn() {
      return this.error && this.showError
    },
    borderColor() {
      return this.errorOn ? 'red' : this.color
    },
    dropdownValue() {
      return this.chosenValue || this.value
    },
    placeholderValue() {
      return this.placeSwitch
    }
  },
  methods: {
    getKeyForOption(option) {
      const randomNumber = Math.floor(Math.random() * 1000)
      return option + randomNumber.toString()
    },
    emitValue() {
      this.$emit('input', this.dropdownValue)
      this.$emit('onClick')
    },
    handleFocus() {
      // update the class list and show the placeholder
      this.$refs.label.classList.add(`${this.bg === 'gray-100' ? '_' : ''}focused`)
      this.placeSwitch = this.placeholder
      this.showError = false
      this.toggleInside()

      this.$emit('focus')
    },
    handleBlur() {
      // update the class list and hide the placeholder
      this.$refs.label.classList.remove(`${this.bg === 'gray-100' ? '_' : ''}focused`)
      this.showError = true
      this.placeSwitch = ''
      this.$emit('blur')
    },
    stickyLabel(val) {
      this.$refs.label.classList.toggle('stick', Boolean(val))
    },
    toggleOutside() {
      this.toggled = false
    },
    toggleInside() {
      this.toggled = true
    },
    handleSelect(d) {
      this.toggled = false
      this.chosenValue = d
      this.emitValue()
    }
  },
  mounted() {
    this.stickyLabel(this.dropdownValue)
  },
  watch: {
    dropdownValue(v) {
      this.stickyLabel(v)
    },
    value(v) {
      /**
       * If the value is changed from outside the component, we need to update the
       * internal value (chosenValue) to be '' if the value is an empty string.
       */
      if (v === '') {
        this.chosenValue = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pb-15px {
  padding-bottom: 15px;
}
label {
  top: 50%;
  left: 16px;
  transition: all 0.15s ease-in-out, box-shadow 0.3s ease-in-out;
  transform-origin: left;
  transform: translateY(-8px) scale(1);
  box-shadow: none;
  &.stick,
  &.focused {
    @apply text-green-400 font-bold;
    transform: translateY(-27px) scale(0.7);
  }
  &._focused {
    @apply text-green-400 font-bold;
    transform: translateY(-27px) scale(0.7);
  }
}
</style>
